<template>
	<DefaultLayout class="TriggerList">
		<ofs-panel>
			<ListTable
				:table-title="$t('Trigger List')"
				:items="triggers"
				:config="config"
				:fields="fieldsArray"
				:total-items="count"
				:per-page="perPage"
				:current-page="currentPage"
				:fetchData="fetchData"
				:isBusy="isLoading"
				:active-filter-options="activeFilterOptions"
				:page-position-prefix="$t('Showing')"
				:page-position-join="$t('of')"
				@table-change="handleTableChange"
				@row-clicked="onTriggerClick"
				hover
			>
				<template slot="prev-text" slot-scope="{}">
					{{ $t('Prev') }}
				</template>
				<template slot="next-text" slot-scope="{}">
					{{ $t('Next') }}
				</template>
				<template slot="empty">
					<span>
						<i>{{ $t('No Data') }}</i>
					</span>
				</template>
				<template v-slot:cell(name)="trigger">{{ trigger.item.name }}</template>
			</ListTable>
		</ofs-panel>
	</DefaultLayout>
</template>

<script>
import _ from 'lodash';
import { OfsPanel, ListTable } from '@workflow-solutions/ofs-vue-layout';
import { mapGetters, mapActions } from 'vuex';
import DefaultLayout from '../../../components/DefaultLayout';

export default {
	components: {
		ListTable,
		DefaultLayout,
		OfsPanel
	},
	data() {
		return {
			perPage: 10,
			currentPage: 1,
			filter: true,
			isLoading: false
		};
	},
	computed: {
		...mapGetters({
			triggersData: 'trigger/triggers',
			count: 'trigger/count'
		}),
		activeFilterOptions() {
			return [
				{ text: this.$t('Active'), value: true },
				{ text: this.$t('Inactive'), value: false }
			];
		},
		fieldsArray() {
			return [{ key: 'name', label: this.$t('Name') }];
		},
		triggers() {
			return _.get(this.triggersData, 'data', []);
		},
		config() {
			return {
				activeFilter: { visible: true, title: this.$t('View Active/Inactive') },
				breadcrumbs: { visible: false }
			};
		}
	},
	mounted() {
		this.fetchData();
	},
	methods: {
		...mapActions({ getTriggers: 'trigger/find' }),
		async fetchData() {
			try {
				this.isLoading = true;
				const query = {
					active: this.filter,
					page: this.currentPage,
					pagesize: this.perPage
				};
				await this.getTriggers({ query });
			} catch (err) {
				this.$notify({
					type: 'error',
					title: this.$t('Error'),
					text: this.$t('An error occurred while fetching triggers')
				});
			} finally {
				this.isLoading = false;
			}
		},
		handleTableChange({ currentPage, perPage, filter }) {
			this.currentPage = currentPage;
			this.perPage = perPage;

			if (filter !== undefined) {
				this.filter = filter;
			}
		},
		onTriggerClick({ _id }) {
			this.$router.push({ name: 'trigger.edit', params: { id: _id } });
		}
	}
};
</script>
